"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATUM_KIND = exports.SIGNAL_INLCUDED_KINDS = exports.SIGNAL_KINDS = void 0;
const stringCapitalize_1 = require("../../utils/stringCapitalize");
const KINDS = [
    'undefined',
    'signal',
    'reference',
    'solvent',
    'standard',
    'p1',
    'p2',
    'p3',
];
exports.SIGNAL_KINDS = KINDS.map((key) => ({
    value: key,
    label: (0, stringCapitalize_1.stringCapitalize)(key),
}));
exports.SIGNAL_INLCUDED_KINDS = ['signal'];
exports.DATUM_KIND = { signal: 'signal', mixed: 'mixed' };
